import React from "react";
import Modal from "../../../../elements/Modal";
import ManagePage from "../ManagePage";

const ManagePageModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl3"
      title={data?._id ? "Update" : "Create New "}
    >
      <ManagePage getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManagePageModal;
